// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"178":"notfound","215":"itemPage","818":"item","933":"auth","949":"cart","962":"home"}[chunkId] || chunkId) + "." + {"35":"85bfa471","178":"589bce0e","215":"638c9f50","818":"589bce0e","933":"f7e78df2","949":"cd08d95d","962":"0f961e34","993":"84119f05"}[chunkId] + ".css";
};